import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 专案组下所有报价单
export const setDpgQuotations: Mutation<IModuleState> = (state, payload) => {
  state.quotations.data = payload.data;
  state.quotations.loading = !!payload.loading;
};

// 报价单详情
export const setDpgQuotationDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type || '';
  state.dialog.data = payload.data || null;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
